import { render, staticRenderFns } from "./RiasocResultsHeader.vue?vue&type=template&id=a23f97cc&scoped=true&"
import script from "./RiasocResultsHeader.vue?vue&type=script&lang=js&"
export * from "./RiasocResultsHeader.vue?vue&type=script&lang=js&"
import style0 from "./RiasocResultsHeader.vue?vue&type=style&index=0&id=a23f97cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23f97cc",
  null
  
)

export default component.exports